import type {ColumnDef} from '@tanstack/react-table';

import {Checkbox} from '@/components/ui/checkbox';

const tableSelectCol = <TData,>(): ColumnDef<TData> => ({
  id: 'select-col',
  enableHiding: false,
  size: 50,
  header: ({table}) => (
    <Checkbox
      checked={
        table.getIsSomeRowsSelected()
          ? 'indeterminate'
          : !!table.getIsAllRowsSelected()
      }
      onCheckedChange={checked => {
        table.getToggleAllPageRowsSelectedHandler()({target: {checked}});
      }}
    />
  ),
  cell: ({row}) => (
    <Checkbox
      onClick={evt => {
        evt.stopPropagation();
      }}
      checked={row.getIsSelected()}
      disabled={!row.getCanSelect()}
      onCheckedChange={checked => {
        row.getToggleSelectedHandler()({target: {checked}});
      }}
    />
  ),
});

export default tableSelectCol;
